import { render, staticRenderFns } from "./listes_services_okba.vue?vue&type=template&id=757c4458&"
import script from "./listes_services_okba.vue?vue&type=script&lang=js&"
export * from "./listes_services_okba.vue?vue&type=script&lang=js&"
import style0 from "./listes_services_okba.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports